import { Col, Row } from "react-bootstrap";

function CardsEleitorado({ locais, secoes, eleitorado, rotas, onOpenModalRotas }) {

    return (
        <Row style={{ marginTop: 15 }}>
            <Col xs={12} sm={12} md={12} lg={12} className="mx-auto" >
                <Row>

                    <Col xs="12" sm>
                        <div className="notice notice-info">
                            <strong>Locais de Votação</strong><br />
                            <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(locais)}</span>
                        </div>
                    </Col>

                    <Col xs="12" sm>
                        <div className="notice notice-info">
                            <strong>Seções</strong><br />
                            <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(secoes)}</span>
                        </div>
                    </Col>

                    <Col xs="12" sm>
                        <div className="notice notice-success">
                            <strong>Eleitorado</strong><br />
                            <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(eleitorado)}</span>
                        </div>
                    </Col>

                    {
                        rotas && (
                            <Col xs="12" sm>
                                <div className="notice notice-success" style={{ display: "flex", flexDirection: "column" }}>
                                    <strong style={{ marginTop: -8 }}>Rotas</strong>
                                    <span style={{ fontSize: "2em", fontWeight: "bold", marginTop: -5 }}>{rotas} </span><span style={{ color: '#007bff', cursor: 'pointer', marginTop: -11, fontSize: 15 }} onClick={onOpenModalRotas}>  <span style={{ paddingTop: 20 }}>Mais Informações</span></span>
                                </div>
                            </Col>
                        )
                    }

                </Row>

            </Col>
        </Row>
    );
}

export default CardsEleitorado;